import React from 'react';
import { Link } from 'react-scroll';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { SiLeetcode, SiHackerrank } from 'react-icons/si';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="home" smooth={true} duration={500} offset={-80}>Home</Link></li>
            <li><Link to="about" smooth={true} duration={500} offset={-80}>About</Link></li>
            <li><Link to="experience" smooth={true} duration={500} offset={-80}>Experience</Link></li>
            <li><Link to="projects" smooth={true} duration={500} offset={-80}>Projects</Link></li>
            <li><Link to="contact" smooth={true} duration={500} offset={-80}>Contact</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Connect</h3>
          <div className="footer-social">
            <a href="https://github.com/Vigneshmunikannan" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/vignesh-m-25909b237" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://leetcode.com/u/vigneshmunikannan/" target="_blank" rel="noopener noreferrer" aria-label="LeetCode">
              <SiLeetcode />
            </a>
            <a href="https://www.hackerrank.com/profile/vigneshmunikann1" target="_blank" rel="noopener noreferrer" aria-label="HackerRank">
              <SiHackerrank />
            </a>
            <a href="mailto:vigneshmunikannan@gmail.com" aria-label="Email">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {currentYear} Vignesh M. All rights reserved. Made with ❤️</p>
      </div>
    </footer>
  );
}

export default Footer;
